export const ru = {
  identity: {
    login: {
      title: 'Вход',
      subtitle: 'Контент-хаб для авторских блогов',
      login: 'Логин',
      password: 'Пароль',
      submit: 'Войти',
      demoTitle: 'Демо-режим',
      demoText: 'Выберите учётную запись, чтобы подставить логин и пароль.',
      demoRole: {
        owner: 'владелец блога',
        editor: 'редактор',
        viewer: 'наблюдатель',
        admin: 'администратор системы',
      },
      noAccount: 'Нет учётной записи?',
      toRegister: 'Зарегистрироваться',
    },
    register: {
      title: 'Регистрация',
      text: 'Учётная запись для работы со своими блогами. Сразу после регистрации вы войдёте и сможете создать блог.',
      login: 'Логин',
      loginHint: 'Латиница, цифры, точка, дефис, подчёркивание; 3–32 символа',
      displayName: 'Имя',
      password: 'Пароль',
      passwordHint: 'Не короче 8 символов',
      passwordRepeat: 'Пароль ещё раз',
      submit: 'Зарегистрироваться',
      closedTitle: 'Регистрация закрыта',
      closed: 'Учётные записи на этой платформе заводит администратор.',
      haveAccount: 'Уже есть учётная запись?',
      toLogin: 'Войти',
    },
    profile: {
      title: 'Профиль',
      account: 'Учётная запись',
      loginLabel: 'Логин: {login}',
      roleAdmin: 'Администратор системы',
      roleUser: 'Пользователь',
      passwordTitle: 'Смена пароля',
      currentPassword: 'Текущий пароль',
      newPassword: 'Новый пароль',
      passwordHint: 'Не короче 8 символов. Другие ваши сессии завершатся.',
      changePassword: 'Сменить пароль',
      passwordChanged: 'Пароль изменён.',
    },
    users: {
      title: 'Пользователи',
      subtitle: 'Учётные записи системы. Самостоятельной регистрации нет — пользователей заводит администратор.',
      create: 'Новый пользователь',
      login: 'Логин',
      displayName: 'Имя',
      password: 'Начальный пароль',
      platformRole: 'Роль в системе',
      roles: {
        admin: 'Администратор',
        user: 'Пользователь',
      },
      status: 'Состояние',
      lastSeen: 'Последняя активность',
      neverSeen: 'не заходил',
      active: 'Активен',
      disabled: 'Заблокирован',
      disable: 'Заблокировать',
      enable: 'Разблокировать',
      makeAdmin: 'Сделать администратором',
      makeUser: 'Сделать пользователем',
      resetPassword: 'Новый пароль',
      plan: 'Тариф',
      openPlan: 'Тариф',
      resetTitle: 'Новый пароль для {login}',
      resetDone: 'Пароль изменён, сессии пользователя завершены.',
      created: 'Пользователь создан.',
      actions: 'Действия',
      empty: 'Пользователей пока нет',
    },
    apiKeys: {
      title: 'Ключи API',
      subtitle: 'Ключ даёт боту или ИИ-агенту доступ к системе от вашего имени без пароля: загружать фото, заводить черновики постов, публиковать.',
      adminTitle: 'Ключи API',
      adminSubtitle: 'Ключи всех пользователей. Для бота удобнее отдельная учётка с ролью редактора в нужных блогах.',
      issue: 'Выпустить ключ',
      issueTitle: 'Новый ключ API',
      issuedTitle: 'Ключ выпущен',
      owner: 'Пользователь',
      ownerSearch: 'Логин или имя',
      name: 'Название',
      nameHint: 'Для кого ключ, например «Бот приёма Telegram».',
      scopesLabel: 'Что можно делать с этим ключом',
      scopes: {
        read: 'Читать блог: посты, медиа, справочники, план',
        content: 'Загружать медиа, создавать и править посты и записи справочников',
        publish: 'Публиковать: получать пакеты публикаций и отмечать выход',
        settings: 'Настраивать блог: правила оформления, справочники и поля постов',
      },
      scopeShort: {
        read: 'чтение',
        content: 'контент',
        publish: 'публикация',
        settings: 'настройки',
      },
      scopesNote:
        'Ключ не даёт больше, чем у пользователя в блоге: настраивать блог может только ключ его владельца. Удаление, участники, статусы, каналы и схемы по ключу недоступны. Правка полей по ключу стирает значения убранных полей во всём блоге.',
      key: 'Ключ',
      created: 'Выпущен',
      lastUsed: 'Использовался',
      neverUsed: 'ещё не использовался',
      status: 'Состояние',
      active: 'Действует',
      revoked: 'Отозван {date}',
      revoke: 'Отозвать',
      revokeConfirm: 'Отозвать ключ «{name}»?',
      revokeText: 'Бот с этим ключом сразу потеряет доступ. Вернуть ключ нельзя — только выпустить новый.',
      deleteConfirm: 'Удалить ключ «{name}»?',
      deleteText: 'Ключ уже отозван и не работает. Он пропадёт из списка навсегда.',
      actions: 'Действия',
      empty: 'Ключей пока нет',
      emptyText: 'Выпустите ключ и передайте его боту вместе со скилом для агентов.',
      secretLabel: 'Ключ API',
      secretWarning: 'Скопируйте ключ сейчас: больше его не покажем. Храните его как пароль и передавайте только боту.',
      copy: 'Скопировать',
      copied: 'Скопировано',
      copyFailed: 'Не удалось скопировать — выделите ключ и скопируйте вручную.',
      helpTitle: 'Как подключить бота или агента',
      helpText:
        'Задайте агенту адрес сервера и ключ, а затем дайте ему скил: в нём описано, как держать локальную копию блога, выгружать и скачивать посты и готовить их по правилам оформления блога. Справочник API описывает всё, что доступно по ключу.',
      serverUrl: 'Адрес сервера',
      guide: 'Справочник API',
      skill: 'Скил для агентов',
      skillZip: 'Скил целиком со скриптом синхронизации (архив)',
      demoText: 'В демо-режиме ключи не выпускаются и не отзываются. Для пробы есть общий тестовый ключ учётки {login} со всеми областями.',
      demoKeyNotice: 'Тестовый ключ демо-стенда. Он общий для всех посетителей и возвращается каждую ночь вместе с демо-данными.',
    },
  },
};

export const en: typeof ru = {
  identity: {
    login: {
      title: 'Sign in',
      subtitle: 'Content hub for author blogs',
      login: 'Login',
      password: 'Password',
      submit: 'Sign in',
      demoTitle: 'Demo mode',
      demoText: 'Pick an account to fill in the login and password.',
      demoRole: {
        owner: 'blog owner',
        editor: 'editor',
        viewer: 'viewer',
        admin: 'system administrator',
      },
      noAccount: 'No account?',
      toRegister: 'Sign up',
    },
    register: {
      title: 'Sign up',
      text: 'An account to work with your blogs. Right after signing up you are signed in and can create a blog.',
      login: 'Login',
      loginHint: 'Latin letters, digits, dot, hyphen, underscore; 3–32 characters',
      displayName: 'Name',
      password: 'Password',
      passwordHint: 'At least 8 characters',
      passwordRepeat: 'Repeat the password',
      submit: 'Sign up',
      closedTitle: 'Sign-up is closed',
      closed: 'Accounts on this platform are created by the administrator.',
      haveAccount: 'Already have an account?',
      toLogin: 'Sign in',
    },
    profile: {
      title: 'Profile',
      account: 'Account',
      loginLabel: 'Login: {login}',
      roleAdmin: 'System administrator',
      roleUser: 'User',
      passwordTitle: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      passwordHint: 'At least 8 characters. Your other sessions will end.',
      changePassword: 'Change password',
      passwordChanged: 'Password changed.',
    },
    users: {
      title: 'Users',
      subtitle: 'System accounts. There is no self sign-up — an administrator creates users.',
      create: 'New user',
      login: 'Login',
      displayName: 'Name',
      password: 'Initial password',
      platformRole: 'System role',
      roles: {
        admin: 'Administrator',
        user: 'User',
      },
      status: 'Status',
      lastSeen: 'Last activity',
      neverSeen: 'never',
      active: 'Active',
      disabled: 'Disabled',
      disable: 'Disable',
      enable: 'Enable',
      makeAdmin: 'Make administrator',
      makeUser: 'Make regular user',
      resetPassword: 'New password',
      plan: 'Plan',
      openPlan: 'Plan',
      resetTitle: 'New password for {login}',
      resetDone: "Password changed, the user's sessions ended.",
      created: 'User created.',
      actions: 'Actions',
      empty: 'No users yet',
    },
    apiKeys: {
      title: 'API keys',
      subtitle: 'A key lets a bot or an AI agent work with the system on your behalf without a password: upload photos, create draft posts, publish.',
      adminTitle: 'API keys',
      adminSubtitle: "All users' keys. For a bot, a separate account with the editor role in the needed blogs is handier.",
      issue: 'Issue key',
      issueTitle: 'New API key',
      issuedTitle: 'Key issued',
      owner: 'User',
      ownerSearch: 'Login or name',
      name: 'Name',
      nameHint: 'Who the key is for, e.g. “Telegram intake bot”.',
      scopesLabel: 'What this key can do',
      scopes: {
        read: 'Read the blog: posts, media, references, plan',
        content: 'Upload media, create and edit posts and reference records',
        publish: 'Publish: get publication packages and mark them as published',
        settings: 'Set up the blog: post style rules, references and post fields',
      },
      scopeShort: {
        read: 'read',
        content: 'content',
        publish: 'publish',
        settings: 'settings',
      },
      scopesNote:
        "A key never gives more than the user's role in the blog: only the blog owner's key can set it up. Deleting, members, statuses, channels and schemes aren't available with a key. Editing fields with a key erases the values of removed fields across the blog.",
      key: 'Key',
      created: 'Issued',
      lastUsed: 'Last used',
      neverUsed: 'never used yet',
      status: 'Status',
      active: 'Active',
      revoked: 'Revoked {date}',
      revoke: 'Revoke',
      revokeConfirm: 'Revoke the key “{name}”?',
      revokeText: "The bot using this key loses access at once. A revoked key can't be restored — only a new one issued.",
      deleteConfirm: 'Delete the key “{name}”?',
      deleteText: "The key is already revoked and doesn't work. It will disappear from the list for good.",
      actions: 'Actions',
      empty: 'No keys yet',
      emptyText: 'Issue a key and hand it to your bot together with the agent skill.',
      secretLabel: 'API key',
      secretWarning: "Copy the key now: it won't be shown again. Keep it like a password and give it only to the bot.",
      copy: 'Copy',
      copied: 'Copied',
      copyFailed: "Couldn't copy — select the key and copy it manually.",
      helpTitle: 'How to connect a bot or an agent',
      helpText:
        'Give the agent the server address and the key, then the skill: it explains how to keep a local copy of the blog, upload and download posts and write them by the blog’s formatting rules. The API guide lists everything available with a key.',
      serverUrl: 'Server address',
      guide: 'API guide',
      skill: 'Agent skill',
      skillZip: 'The whole skill with the sync script (archive)',
      demoText: "Keys aren't issued or revoked in demo mode. To try the API there is a shared test key of the {login} account with all scopes.",
      demoKeyNotice: 'The demo stand test key. It is shared by all visitors and comes back every night with the demo data.',
    },
  },
};
